<template>
  <b-card>
    <div class="col-sm-12">
      <h4 class="h4-title">{{pageTitle}}</h4>
      <form>
        <b-row>
          <b-col
            class="form-group"
            cols="4"
          >
            <label for="formGroupExampleInput">{{text.firstName}}</label>
            <input
              type="text"
              class="form-control"
              id="first-name"
              :placeholder="text.firstName"
              v-model="ResidentProfile.firstName"
              required
            >
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label for="formGroupExampleInput">{{text.middleName}}</label>
            <input
              type="text"
              class="form-control"
              id="middle-name"
              :placeholder="text.middleName"
              v-model="ResidentProfile.middleName"
              required
            >
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label for="formGroupExampleInput">{{text.lastName}}</label>
            <input
              type="text"
              class="form-control"
              id="last-name"
              :placeholder="text.lastName"
              v-model="ResidentProfile.lastName"
              required
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.mobile}}</label>
            <the-mask id="mobile" class="form-control" :mask="['###-###-####']" v-model="ResidentProfile.mobile" :masked="false" type="tel" placeholder="xxx-xxx-xxxx" />
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.email}}</label>
            <input
              type="text"
              class="form-control"
              id="email"
              :placeholder="text.email"
              v-model="ResidentProfile.email"
              required
            >
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.idCardAndPassport}}</label>
            <input
              type="text"
              class="form-control"
              id="idCard"
              :placeholder="text.idCardAndPassport"
              v-model="ResidentProfile.idCard"
              required
            >
          </b-col>
        </b-row>
        <b-row>
          <!-- tenant -->
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.residentType}}</label>
            <v-select :clearable="false"
                  v-model="ResidentProfile.residentType"
                 :options="['tenant', 'owner']">
            </v-select>
          </b-col>
          <b-col v-if="'tenant' === ResidentProfile.residentType"
          class="form-group" cols="4">
            <label>Rent Date</label>
              <v-date-picker
                    mode='range'
                    locale="th-TH"
                    color="gray"
                    :columns="$screens({ default: 1, lg: 2 })"
                    :popover="{ visibility: 'click', placement: 'bottom' }"
                    :input-props="{ placeholder: 'Please enter date start and finish', readonly: true }"
                    v-model='rentDate'
                    >
                </v-date-picker>
          </b-col>
        </b-row>

        <b-row v-if="ResidentProfile.syncedToUserAt">
          <b-col class="form-group" cols="4">
            <label>Synced At</label>
            <label class="form-control">{{ toLocalDateTime(ResidentProfile.syncedToUserAt.timestamp) }}</label>
          </b-col>
        </b-row>
        <b-row v-if="editable">
          <div class="col-sm-2 col-200">
            <button
              type="button"
              class="btn action-b-btn b-btn"
              :disabled="isUpdating"
              @click="saveResident"
            >
              <b-spinner
                small
                v-if="isUpdating"
              ></b-spinner>
              {{text.save}}
            </button>
          </div>
          <div class="col-sm-2 col-100" v-if="editMode">
            <button
              type="button"
              class="btn action-b-btn b-btn"
              @click="addProject"
            >
              {{text.addProjectBtnCaption}}
            </button>
          </div>
          <div class="col-sm-2 col-100">
              <b-button
              variant="danger"
              class="btn b-btn action-b-btn delete-b-btn"
              @click="deleteResident"
              v-b-tooltip.hover
              :title="text.deleteResident"
              v-if="editMode"
            >
              {{text.deleteResident}}
            </b-button>
          </div>
        </b-row>
        <hr />
        <div>
          <div class="form-group row">
            <div class="col-lg-12">
              <b-alert
                variant="success"
                dismissible
                fade
                :show="saveDone"
              >
                {{saveSuccessMessage}}
              </b-alert>
              <b-alert
                variant="danger"
                dismissible
                fade
                :show="saveError"
              >
                {{errorMessage}}
              </b-alert>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12" v-if="residentProjects.length > 0">
      <h4>{{text.projects}}</h4>
      <b-row
        v-for="(project) in residentProjects"
        v-bind:key="project.projectCode"
      >
        <b-col>
          <div>
            <h5>{{getProjectName(project.projectCode)}}</h5>
            <b-button
              size="sm"
              class="mr-1 grant-b-btn btn-add-unit"
              @click="addUnit(project.projectCode)"
              v-b-tooltip.hover
              title="Add unit"
              v-if="editable"
            >
              {{text.addUnit}}
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              class="mr-1 btn-add-unit"
              @click="deleteProject(project.projectCode)"
              v-b-tooltip.hover
              :title="text.deleteProject"
              v-if="editable"
            >
              {{text.deleteProject}}
            </b-button>
          </div>
          <div>
            <b-table
              stacked="sm"
              class="table-app"
              tbody-class="tbody"
              hover
              thead-tr-class="thead-app"
              selectedVariant="single"
              :selectable="true"
              :fields="fields"
              :items="project.units"
            >
              <template
                slot="unitNumber"
                slot-scope="row"
              >
                {{ row.item.unitNumber }}
              </template>
              <template
                slot="createdAt"
                slot-scope="row"
              >
                {{ toLocalDateTime(row.item.createdAt.timestamp) }}
              </template>
              <template
                slot="updatedAt"
                slot-scope="row"
              >
                {{ toLocalDateTime(row.item.updatedAt.timestamp) }}
              </template>
              <template
                slot="actions"
                slot-scope="row"
              >
                <b-button
                  type="button"
                  size="sm"
                  class="btn btn-edit-transparent"
                  @click="editUnit(project.projectCode, row.item.id, row.item.unitNumber)"
                  v-b-tooltip.hover
                  :title="text.updateUnit"
                  v-if="editable"
                >
                  <i class="fa fa-edit"></i>
                </b-button>
                <button
                  type="button"
                  class="btn"
                  @click="deleteUnit(project.projectCode, row.item.id)"
                  v-b-tooltip.hover
                  :title="text.deleteUnit"
                  v-if="editable"
                ><i class="fa fa-trash"></i></button>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import { dateToStringWithTimeFull } from '@/assets/utils/time.js';
import MqdcOneClient from '@/models/mqdc-one-client';
import { currentUserProjects } from '@/assets/utils/user';
import { textResident } from '@/assets/utils/language';
import { TheMask } from 'vue-the-mask';
import { PNF, phoneUtil } from '@/assets/utils/phone-util';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
  name: 'Resident',
  props: ['id'],
  data () {
    return {
      ResidentProfile: {
        firstName: '',
        middleName: '',
        lastName: '',
        mobile: '',
        email: '',
        idCard: '',
        syncedToUserAt: '',
        residentType: 'owner',
        tenantPeriodStart: null,
        tenantPeriodEnd: null
      },
      rentDate: {
        start: null,
        end: null
      },
      fields: [],
      selectedProject: null,
      projects: [],
      residentProjects: [],
      saveDone: false,
      saveError: false,
      isUpdating: false,
      editMode: false,
      editable: true,
      saveSuccessMessage: 'Successfully saved!',
      updateSuccessMessage: 'Successfully updated!',
      deleteUnitWarning: 'Are you sure to delete this Unit?',
      deleteUnitSuccess: 'Deleted Unit successfully.',
      deleteProjectWarning: 'Are you sure to delete this Project?',
      deleteProjectSuccess: 'Deleted Project successfully.',
      deleteResidentWarning: 'Are you sure to delete this resident?',
      deleteResidentSuccess: 'Resident has been deleted successfully.',
      successMessage: '',
      errorMessage: '',
      verifyBtnCaption: 'Verify',
      pageTitle: 'Add Resident',
      mqdcOneClient: {},
      confirmBoxOptions: {
        title: 'Please confirm!',
        text: '',
        type: 'question',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#339DAA',
        cancelButtonText: 'No',
        cancelButtonColor: '#d33',
        width: 500,
        animation: true,
        padding: '3em',
        background: '#fff'
      },
      alertBoxOptions: {
        confirmButtonColor: '#339DAA'
      },
      text: {}
    };
  },
  mounted () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    this.text = textResident(this.$language);
    this.refreshFields();
    this.pageTitle = 'Add Resident' === this.$route.meta.label ? this.text.addResident : this.text.editResident;
    document.title = this.pageTitle;
    if ('one_app_residents-add' === this.$route.name) {
      this.editMode = false;
    } else if ('one_app_residents-edit' === this.$route.name) {
      this.editMode = true;
    }
    if (this.editMode) {
      this.getResident();
    }
    this.loadProjects();
  },
  watch: {
    '$route' (to, from) {
      if ('one_app_residents-add' === to.name) {
        let addResidentURL = this.$router.resolve({ name: 'one_app_residents-add' }).href;
        document.location = addResidentURL;
      }
    },
    $language: function () {
      this.text = textResident(this.$language);
      this.refreshFields();
    }
  },
  methods: {
    async getResident () {
      try {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}`;
        const residentProfile = await this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(url);
        });
        this.ResidentProfile = residentProfile.data.data;
        this.editable = this.ResidentProfile.editable;
        this.residentProjects = this.ResidentProfile.projects;
        this.filterProjectByPermission();
        if ('tenant' === this.ResidentProfile.residentType) {
          this.rentDate = {
            start: new Date(this.ResidentProfile.tenantPeriodStart.timestamp * 1000),
            end: new Date(this.ResidentProfile.tenantPeriodEnd.timestamp * 1000)
          };
        }
        if (this.ResidentProfile.mobile) {
          this.ResidentProfile.mobile = phoneUtil.format(phoneUtil.parseAndKeepRawInput(this.ResidentProfile.mobile, 'TH'), PNF.NATIONAL);
        }
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    postResident () {
      const residentProfile = {
        'firstName': this.ResidentProfile.firstName,
        'lastName': this.ResidentProfile.lastName,
        'middleName': this.ResidentProfile.middleName,
        'email': this.ResidentProfile.email,
        'mobile': this.ResidentProfile.mobile,
        'idCard': this.ResidentProfile.idCard,
        'residentType': this.ResidentProfile.residentType,
        'tenantPeriodStart': this.tenantPeriodStart,
        'tenantPeriodEnd': this.tenantPeriodEnd
      };
      try {
        this.isUpdating = true;
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents`;
        this.mqdcOneClient.getAxios().then(axios => {
          axios.post(url, residentProfile).then(response => {
            this.getResident();
            this.saveDone = true;
            this.successMessage = this.saveSuccessMessage;
            this.isUpdating = false;
            this.$alert(this.saveSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => {
              let editUrl = this.$router.resolve({ name: 'one_app_residents-edit', params: { id: response.data.data.id } }).href;
              document.location = editUrl;
            });
          }).catch(error => {
            this.saveError = true;
            this.saveDone = false;
            this.successMessage = '';
            this.errorMessage = error.response.data.message;
            this.$alert(`${error.response.data.message}`, 'Error', 'error').then(() => { });
            console.log(error.response);
            this.isUpdating = false;
          });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    patchResident () {
      const residentProfilePatch = {
        'firstName': this.ResidentProfile.firstName,
        'lastName': this.ResidentProfile.lastName,
        'middleName': this.ResidentProfile.middleName,
        'email': this.ResidentProfile.email,
        'mobile': this.ResidentProfile.mobile,
        'idCard': this.ResidentProfile.idCard,
        'residentType': this.ResidentProfile.residentType,
        'tenantPeriodStart': this.tenantPeriodStart,
        'tenantPeriodEnd': this.tenantPeriodEnd
      };
      try {
        this.isUpdating = true;
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}`;
        this.mqdcOneClient.getAxios().then(axios => {
          axios.patch(url, residentProfilePatch).then(response => {
            this.getResident();
            this.saveDone = true;
            this.successMessage = this.updateSuccessMessage;
            this.$alert(this.updateSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => { });
            this.isUpdating = false;
          }).catch(error => {
            this.saveError = true;
            this.saveDone = false;
            this.successMessage = '';
            this.errorMessage = error.response.data.message;
            this.$alert(`${error.response.data.message}`, 'Error', 'error').then(() => { });
            console.log(error.response);
            this.isUpdating = false;
          });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    saveResident () {
      if (this.editMode) {
        this.patchResident();
      } else if (false === this.editMode) {
        this.postResident();
      }
    },
    deleteResident () {
      this.confirmBoxOptions.text = this.deleteResidentWarning;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                this.$alert(this.deleteResidentSuccess, 'Success', 'success', this.alertBoxOptions).then(() => { });
                this.$router.push({ name: 'one_app_residents' });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error);
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    deleteProject (projectCode) {
      this.confirmBoxOptions.text = this.deleteResidentWarning;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}/projects/${projectCode}`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                this.getResident();
                this.$alert(this.deleteProjectSuccess, 'Success', 'success', this.alertBoxOptions).then(() => { });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error);
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    deleteUnit (projectCode, unitId) {
      this.confirmBoxOptions.text = this.deleteUnitWarning;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}/projects/${projectCode}/units/${unitId}`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                this.getResident();
                this.$alert(this.deleteUnitSuccess, 'Success', 'success', this.alertBoxOptions).then(() => { });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error.response);
                  this.$alert('Unexpected Error.', 'Error', 'error').then(() => { });
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    async loadProjects () {
      try {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/projects`;
        const projectsResponse = await this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(
            url
          );
        });
        if (!projectsResponse) {
          this.$router.push({ name: 'one_app_residents' });
        }
        this.projects = projectsResponse.data.data;
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    filterProjectByPermission () {
      const currentUsersProjectCodes = currentUserProjects();
      if (currentUsersProjectCodes.length > 0) {
        const permittedProjects = this.residentProjects.filter(po => {
          return currentUsersProjectCodes.includes(po.projectCode);
        });
        if (permittedProjects.length > 0) {
          if (!currentUsersProjectCodes.includes('*')) {
            this.residentProjects = permittedProjects;
          }
        }
      }
    },
    getProjectName (code) {
      if (0 === this.projects.length) {
        return null;
      }
      const ps = this.projects.filter(p => { return p.code === code; });
      return ps.length > 0 ? ps[0].name : null;
    },
    toLocalDateTime (dt) {
      return dateToStringWithTimeFull(new Date(dt * 1000));
    },
    addProject () {
      this.$router.push({ name: 'one_app_residents-project' });
    },
    addUnit (projectCode) {
      this.$router.push({ name: 'one_app_residents-unit', params: { id: this.id, projectcode: projectCode } });
    },
    editUnit (projectCode, id, unitNumber) {
      sessionStorage.setItem('unitnumber', unitNumber);
      this.$router.push({ name: 'one_app_residents-unit-edit', params: { id: this.id, projectcode: projectCode, unitId: id } });
    },
    refreshFields () {
      this.saveSuccessMessage = this.text.saveSuccessMessage;
      this.updateSuccessMessage = this.text.updateSuccessMessage;
      this.deleteUnitWarning = this.text.deleteUnitWarning;
      this.deleteUnitSuccess = this.text.deleteUnitSuccess;
      this.deleteProjectWarning = this.text.deleteProjectWarning;
      this.deleteProjectSuccess = this.text.deleteProjectSuccess;
      this.deleteResidentWarning = this.text.deleteResidentWarning;
      this.deleteResidentSuccess = this.text.deleteResidentSuccess;
      this.confirmBoxOptions.title = this.text.pleaseConfirm;
      this.confirmBoxOptions.confirmButtonText = this.text.yes;
      this.confirmBoxOptions.cancelButtonText = this.text.no;
      this.fields = [
        { key: 'unitNumber', label: this.text.unitNumber },
        { key: 'createdAt', label: this.text.createdAt },
        { key: 'updatedAt', label: this.text.updatedAt },
        { key: 'actions', label: this.text.actions }
      ];
    }
  },
  computed: {
    mobileText () {
      if (this.ResidentProfile.mobile) {
        return phoneUtil.format(phoneUtil.parseAndKeepRawInput(this.ResidentProfile.mobile, 'TH'), PNF.NATIONAL);
      } else {
        return null;
      }
    },
    tenantPeriodStart () {
      if (!this.rentDate.start) return null;
      const date = moment(this.rentDate.start);
      return date.utc().format('YYYY-MM-DD HH:mm');
    },
    tenantPeriodEnd () {
      if (!this.rentDate.end) return null;
      const date = moment(this.rentDate.end);
      return date.hour(23).minute(59).utc().format('YYYY-MM-DD HH:mm');
    }
  },
  components: {
    TheMask,
    'v-select': vSelect
  }
};
</script>
<style scoped src="@/assets/css/userprofile.css"></style>
